<template>
  <!-- Header -->
  <q-card-section>
    <div class="text-h6">
      <template v-if="type">
        <!-- Avatar -->
        <q-avatar :color="type.color" text-color="white" :icon="type.icon" size="md" />
        <!-- Label -->
        {{ ` ${activityLabel(type.type)}` }}
      </template>
      <template v-else-if="headerText">
        {{ headerText }}
      </template>
    </div>
  </q-card-section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { NavActivity } from '../types/navigation'

export default defineComponent({
  props: {
    /**Type of nav activity */
    type: {
      required: false,
      type: Object as PropType<NavActivity>,
      default: undefined,
    },
    /**Text */
    headerText: {
      required: false,
      type: String,
      default: undefined,
    },
  },
  setup() {
    const { t } = useI18n({ useScope: 'global' })

    const activityLabel = (key: string) => t(`activities.${key}`)

    return {
      activityLabel,
    }
  },
})
</script>
